import {ILogObj, Logger} from "tslog";

async function getMinLogLevel(): Promise<number> {
  const envLogLevel = parseInt(process.env.NEXT_PUBLIC_TSLOG_MIN_LEVEL!, 10);

  console.log("Logger envLogLevel: ", envLogLevel);

  if (typeof window !== 'undefined') {
    const match = document.cookie.match(/minLevel=(\d+)/);
    const number = match ? parseInt(match[1]!, 10) : envLogLevel;

    console.log("Logger minLevel (client): ", number);

    return number;
  }
  return envLogLevel;
}

/**
 * To change log-level during runtime, execute this line in the browser's console:
 *
 * document.cookie = "minLevel=1; path=/";
 *
 */
export async function getRootLogger(): Promise<Logger<ILogObj>> {
  return new Logger({
    type: "pretty",
    name: "RootLogger",
    minLevel: await getMinLogLevel(),
  });
}

/**
 * Extracts the file name from a module URL (pass in import.meta.url).
 */
export function getCurrentFileName(metaUrl: string): string {
    const parts = metaUrl.split('/');
    return parts[parts.length - 1] || 'unknown';
}

export default getRootLogger;